import { ShipPageLayout } from "../components/Layouts/ShipPageLayout";
import { ShipForm } from "../components/Form/Forms/Ship/ShipForm";
import { PageHeading } from "../components/Headings/PageHeading";

export function Ship() {
  return (
    <ShipPageLayout>
      <div className="mb-20">
        <PageHeading title="Create a shipment" withBreadcrumbs={true} />
      </div>
      <ShipForm />
    </ShipPageLayout>
  );
}
